import axios from 'axios'; // Օգտագործիր ստանդարտ axios-ը

const apiClient = axios.create({
    baseURL: 'https://nexus-api.dev',
});

export class ApiRequest {
    async checkEmailStatus(email: string) {
        try {
            const response = await apiClient.get('/v1/email-status', {
                params: { email }
            });

            return {
                success: response.data.success,
                message: response.data.message || 'Success'
            };
        } catch (err: any) {
            const errorMessage = err.response?.data?.message || 'Something went wrong';
            const errorStatus = err.response?.status || 500;

            return {
                success: false,
                status: errorStatus,
                message: errorMessage
            };
        }
    }


      async sendOtp(email: string, method: string) {
        try {
           const response = await apiClient.post('/v1/send-otp', {
                email,
                method
            });

            return response.data
        } catch (err: any) {
            const errorMessage = err.response?.data?.message || 'Something went wrong';
            const errorStatus = err.response?.status || 500;

            return {
                success: false,
                status: errorStatus,
                message: errorMessage
            };
        }
    }

    async verifyOtp(email: string, method: string, otp: string) {
        try {
            const response = await apiClient.post('/v1/verify-otp', {
                email,
                method,
                otp
            });

            return response.data
        } catch (err: any) {
            const errorMessage = err.response?.data?.message || 'Something went wrong';
            const errorStatus = err.response?.status || 500;

            return {
                success: false,
                status: errorStatus,
                message: errorMessage
            };
        }
    }
}